import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdatePinnedViewMutation,
  UpdatePinnedViewMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const updatePinnedView = graphql(`
  mutation updatePinnedView($input: UpdatePinnedSavedViewRequest!) {
    updatePinnedView(UpdatePinnedSavedViewRequest: $input) {
      id
      rank
    }
  }
`);

export function useUpdatePinnedView(
  options?: UseMutationOptions<
    UpdatePinnedViewMutation,
    unknown,
    UpdatePinnedViewMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(updatePinnedView, {
    ...options,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["savedViews"] });
    },
  });

  return { data: data?.updatePinnedView, ...rest };
}
